export default __webpack_public_path__ + "static/media/comsuption.e8d789ae.png";